/**
 *
 *
 *
 */
export const tryGetSingleAssignedElement = (slot: HTMLSlotElement): Element | undefined => {
  const assignedElements = slot.assignedElements();
  if (assignedElements.length === 1) {
    return assignedElements[0] instanceof HTMLSlotElement
      ? tryGetSingleAssignedElement(assignedElements[0])
      : assignedElements[0];
  }
  return undefined;
};
